/**
 * Where a notification navigates on click.
 *
 * `sabha.notifications` carries `meeting_id` since migration 004, so an
 * `action_assigned` notification links straight to that meeting's Actions
 * tab -- no lookup needed. The workspace-wide `/actions` list is the
 * fallback for a notification written before `meetingId` was selected, or
 * for one whose action item has since been deleted (`meetingId` present,
 * item gone -- the meeting page just won't find it to highlight).
 *
 * This is the single place the URL is built: both the `<Link>`'s href (so a
 * middle-click / ctrl-click still opens something sensible in a new tab)
 * and the plain-click handler in `NotificationBell` call this, so there is
 * only ever one URL shape to keep in sync.
 *
 * Every other kind keeps its stored `href` unchanged.
 */
export function notificationHref(item: {
  kind: string
  href: string | null
  actionItemId: string | null
  meetingId: string | null
}): string {
  if (item.kind === 'action_assigned' && item.actionItemId) {
    if (item.meetingId) {
      return (
        `/meetings/${encodeURIComponent(item.meetingId)}` +
        `?tab=actions&actionItemId=${encodeURIComponent(item.actionItemId)}`
      )
    }
    return `/actions?actionItemId=${encodeURIComponent(item.actionItemId)}`
  }
  return item.href ?? '#'
}
